module.exports = __webpack_public_path__ + "img/saizi3.57bd3047.png";